export default {
  computed: {
    displayHeader() {
      return !(this.$mq === 'm992' || this.$mq === 'm1200')
    }
  }
}
